import ReferralTableTabGroup from "./ReferralTableTabGroup"
import { useState } from "react"

const ReferralRewardsModal = ({ isOpen, onClose }: any) => {
  const activeTableButtons = ["Referrer", "Referee"]
  const [activeTableButtonType, setActiveTableButtonType] = useState<string>("Referrer")
  const courses = {
    Accelerator: "₹3,000",
    Transformer: "₹5,000",
    Evolve: "₹6,000",
    "Data Science": "₹5,000",
    "Data Analytics": "₹4,000",
    "Data Engineering": "₹5,000",
  }

  function changeActiveTableButtonType(index: number) {
    const tabType = ["Referrer", "Referee"][index]
    setActiveTableButtonType(tabType)
  }
  return (
    <div className="p-[24px] bg-[#F9F9F9]">
      <div className="flex justify-between py-2">
        <p className="text-[18px] font-[600] text-[#162456] mb-1">Referral Rewards</p>
      </div>
      <div className="bg-white  border-[#D3D3D3] border-[0.5px] rounded-[6px] shadow-md">
        <div className="mx-[16px]">
          <p className="text-[var(--color-shades-bw-gray-600, #333)] text-[16px] font-[500] my-[16px]">
            What is Referral cash back Structure ?
          </p>
          <ReferralTableTabGroup
            buttons={activeTableButtons}
            active={activeTableButtons.indexOf(activeTableButtonType)}
            onChange={changeActiveTableButtonType}
          />
        </div>
        {activeTableButtonType === "Referrer" && (
          <div className="bg-white p-4 rounded-md shadow-md">
            <table className="w-full border border-gray-300 border-collapse">
              <thead>
                <tr className="text-sm text-gray-600 border-b border-gray-300">
                  <th className="py-2 px-4 text-left">Referrer Type</th>
                  <th className="py-2 px-4 text-right">₹ Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="py-3 px-4 border-b border-gray-300">
                    <div className="bg-gray-100 text-gray-800 py-2 px-3 rounded-md shadow-sm">Mentor / Instructor</div>
                  </td>
                  <td className="py-3 px-4 border-b border-gray-300">
                    <div className="bg-gray-100 text-gray-900 font-semibold py-2 px-3 rounded-md text-right shadow-sm">
                      ₹3000
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {activeTableButtonType === "Referee" && (
          <div className="bg-white p-4 rounded-md shadow-md">
            <table className="w-full border border-gray-300 border-collapse bg-white rounded-md">
              <thead>
                <tr className="text-sm text-gray-600 border-b border-gray-300">
                  {Object.keys(courses).map((courseType) => (
                    <th key={courseType} className="py-2 px-4 font-medium text-center">
                      {courseType}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Object.values(courses).map((amount, index) => (
                    <td key={index} className="p-2 border-b border-gray-300">
                      <div className="bg-gray-200 text-gray-800 text-center py-2 px-4 rounded-md shadow-md w-full max-w-xs mx-auto">
                        {amount}
                      </div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default ReferralRewardsModal
